import React from 'react';

import Rotaryinje from './Rotaryinje';
import Rotaryfeatu from './Rotaryfeatu';
import Costmetic from './Costmetic';
import Bluecovers from './Bluecovers';




const Rotaryinjectionibm = () => {
    return (
        <div>
            < Rotaryinje />
            < Rotaryfeatu />
            < Costmetic />
            < Bluecovers />

        </div>
    );
};

export default Rotaryinjectionibm;
